// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.demo_container {
  width: 100%;
  height: 1200px iframe;
  height-border: 0;
  height-box-shadow: none;
  height-background-color: red;
}

.inner_container {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/deposit/deposit-paynearme-v2/deposit-paynearme-v2.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,qBAAA;EAEI,gBAAA;EACA,uBAAA;EACA,4BAAA;AAAR;;AAIA;EACI,WAAA;EACA,YAAA;AADJ","sourcesContent":[".demo_container {\r\n    width: 100%;\r\n    height: 1200px\r\n    iframe {\r\n        border: 0;\r\n        box-shadow: none;\r\n        background-color: red;\r\n        // frameBorder: 0;\r\n    }\r\n}\r\n.inner_container {\r\n    width: 100%;\r\n    height: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
